import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageview } from "@/lib/analytics";

/**
 * Fires a GA4 page_view every time the SPA route changes.
 * A small delay lets react-helmet-async update document.title first.
 */
export default function usePageTracking() {
  const location = useLocation();
  useEffect(() => {
    const t = setTimeout(() => trackPageview(location.pathname), 350);
    return () => clearTimeout(t);
  }, [location.pathname]);
}
